/**
 * Social Share
 */
const SocialShare = (() => {
  const Config = {
    Link: '.share-btn',
    Width: 500,
    Height: 500,
  };

  const init = () => {
    // console.log('Ready For Share');
    var slink = document.querySelectorAll(Config.Link);
    for (var a = 0; a < slink.length; a++) {
      slink[a].onclick = PopupHandler;
    }
  };

  const PopupHandler = e => {
    e = e ? e : window.event;
    var link = e.currentTarget;
    // popup position
    var px = Math.floor(((screen.availWidth || 1024) - Config.Width) / 2),
      py = Math.floor(((screen.availHeight || 700) - Config.Height) / 2);

    // console.log(e.currentTarget);
    // console.log(t.srcElement);

    //let link = t.closest('button');
    // console.log(link.dataset.socialNetwork);

    let url = encodeURIComponent(document.location.href);
    let title = encodeURIComponent(document.title);
    let linkToShare = '';

    switch (link.dataset.socialNetwork) {
      case 'Facebook':
        linkToShare = `https://www.facebook.com/sharer.php?u=${url}`;
        break;

      case 'Twitter':
        linkToShare = `https://twitter.com/share?url=${url}&text=${title}`;
        break;

      case 'WhatsApp':
        linkToShare = `https://api.whatsapp.com/send?text=${url}`;
        break;
    }

    // console.log(linkToShare);

    if (linkToShare === '') return false;
    // open popup
    var popup = window.open(
      linkToShare,
      'social',
      'width=' +
        Config.Width +
        ',height=' +
        Config.Height +
        ',left=' +
        px +
        ',top=' +
        py +
        ',location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1'
    );
    if (popup) {
      popup.focus();
      if (e.preventDefault) e.preventDefault();
      e.returnValue = false;
    }
    return !!popup;
  };

  return {
    init: init,
  };
})();

SocialShare.init();
